import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

export default function Breadcrumb() {
  const location = useLocation();

  const getBreadcrumbs = (): BreadcrumbItem[] => {
    const pathParts = location.pathname.split('/').filter(Boolean);
    const breadcrumbs: BreadcrumbItem[] = [{ label: '首页', path: '/' }];

    if (pathParts.length === 0) return breadcrumbs;

    if (pathParts[0] === 'category' && pathParts[1]) {
      const catMap: Record<string, string> = {
        movie: '电影',
        'tv-series': '电视剧',
        variety: '综艺',
        anime: '动漫',
        documentary: '纪录片',
      };
      breadcrumbs.push({ label: catMap[pathParts[1]] || pathParts[1] });
    } else if (pathParts[0] === 'article' && pathParts[1]) {
      breadcrumbs.push({ label: '影片详情', path: '/category/all' });
      breadcrumbs.push({ label: '正在播放' });
    } else if (pathParts[0] === 'about') {
      breadcrumbs.push({ label: '关于我们' });
    }

    return breadcrumbs;
  };

  const breadcrumbs = getBreadcrumbs();

  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-8 py-4">
      <ol className="flex items-center gap-2 text-sm">
        {breadcrumbs.map((item, index) => (
          <li key={index} className="flex items-center gap-2">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
            )}
            {item.path ? (
              <Link
                to={item.path}
                className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium whitespace-nowrap">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}